import isNil from 'lodash/isNil';

const exp = /\{\{\s*(.*?)\s*\}\}/g;

const filters = {
  pluralize: (varName, filterValue, data) => {
    const [singular, plural] = filterValue.split(',');
    if (!plural) {
      return '';
    }

    const value = data[varName];
    if (isNil(value)) {
      return '';
    }

    return +value === 1 ? singular : plural;
  },
};

const renderFilter = (templateVar, data) => {
  // For the time being, does not support chaining unless needed
  const [, varName, filterStr] = templateVar.match(/^([\w-]+)\|([^]+)$/) || [];
  if (!varName) {
    return '';
  }

  const [, filterName = '', filterValue] = filterStr.match(/^([\w]+):"([^]+)"$/) || [];
  const filterFn = filters[filterName.toLowerCase()];
  if (!filterFn) {
    return '';
  }

  return filterFn(varName, filterValue, data);
};

const stache = (template, data = {}) =>
  template.replace(exp, (match, submatch) => {
    const filterValue = renderFilter(submatch, data);
    if (filterValue) {
      return filterValue;
    }

    const value = data[submatch];
    return !isNil(value) ? value : '';
  });

export default stache;



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/stache.js